import { postMessagetoMobileIfPresent } from './messageUtils'

type MobileVibrationType =
  | 'impactLight'
  | 'impactMedium'
  | 'impactHeavy'
  | 'rigid'
  | 'soft'
  | 'notificationSuccess'
  | 'notificationWarning'
  | 'notificationError'
  | 'selection'

// Supported types are listed below
// https://www.npmjs.com/package/react-native-haptic-feedback
export const vibrateMobileIfPresent = (vibrationType: MobileVibrationType) => {
  postMessagetoMobileIfPresent(vibrationType, 'haptic')
}
